import React from 'react';

export function Card({
  children,
  media = null,
  accent = 'burgundy',
  interactive = true,
  padding = '25px',
  href,
  onClick,
  style = {},
  ...rest
}) {
  const accents = {
    burgundy: { border: 'var(--burgundy-700)', shadow: 'var(--shadow-lg)' },
    navy: { border: 'var(--navy-800)', shadow: 'var(--shadow-blue)' },
    tan: { border: 'var(--tan-600)', shadow: '0 15px 40px rgba(139,115,85,0.18)' },
  };
  const a = accents[accent] || accents.burgundy;

  const base = {
    display: 'block',
    background: 'var(--surface-card)',
    border: '2px solid var(--border-soft)',
    borderRadius: 'var(--radius-lg)',
    overflow: 'hidden',
    textDecoration: 'none',
    color: 'inherit',
    boxShadow: 'var(--shadow-md)',
    transition: 'transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease), border-color var(--dur) var(--ease)',
    cursor: (href || onClick) ? 'pointer' : 'default',
    ...style,
  };

  const onEnter = (e) => {
    if (!interactive) return;
    e.currentTarget.style.transform = 'translateY(-5px)';
    e.currentTarget.style.boxShadow = a.shadow;
    e.currentTarget.style.borderColor = a.border;
  };
  const onLeave = (e) => {
    if (!interactive) return;
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = 'var(--shadow-md)';
    e.currentTarget.style.borderColor = 'var(--border-soft)';
  };

  const Tag = href ? 'a' : 'div';
  const linkProps = href ? { href } : {};

  return (
    <Tag style={base} onMouseEnter={onEnter} onMouseLeave={onLeave} onClick={onClick} {...linkProps} {...rest}>
      {media}
      <div style={{ padding }}>{children}</div>
    </Tag>
  );
}

export function CardMedia({ image = null, icon = null, gradient = 'var(--gradient-brand)', height = '200px' }) {
  return (
    <div
      style={{
        height,
        background: image ? `center/cover no-repeat url(${image})` : gradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '56px',
      }}
    >
      {!image && icon}
    </div>
  );
}
